import { createRouter, createWebHashHistory } from "vue-router";

const routes = [{
        path: "/",
        component: () => import("../views/index.vue"),
    },
    {
        path: "/aiTeachingSystem",
        redirect: "/"
    },
    {
        path: "/login",
        component: () => import("../views/Login.vue"),
    }
];

// 导出路由对象
export const router = createRouter({
    history: createWebHashHistory(),
    routes,
});
